import { render, staticRenderFns } from "./ApprovalRequestLineComments.vue?vue&type=template&id=86fb004a"
import script from "./ApprovalRequestLineComments.vue?vue&type=script&lang=js"
export * from "./ApprovalRequestLineComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports